import { forwardRef } from 'react';
import { IPageSection } from '../../types';
import { ITRSection } from './itr-section';
import { GenericSection } from './generic-section';

export const FileWithCTSection: React.FC<IPageSection> = forwardRef(
  (
    { id, postData, metaData },
    ref: React.ForwardedRef<HTMLDivElement>
  ): JSX.Element => {
    if (!postData || !metaData) return <></>;
    return (
      <div data-testid={id} id={id} ref={ref}>
        <GenericSection postData={postData} metaData={metaData} />
        <ITRSection postData={postData} metaData={metaData} />
      </div>
    );
  }
);

FileWithCTSection.displayName = 'FileWithCTSection';
